/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconCategoryMinus = createReactComponent("category-minus", "IconCategoryMinus", [
  [
    "path",
    { d: "M4 4h6v6h-6zm10 0h6v6h-6zm-10 10h6v6h-6zm10 3h6", key: "svg-0" }
  ]
]);

export { IconCategoryMinus as default };
//# sourceMappingURL=IconCategoryMinus.js.map
